import 'bootstrap-timepicker';
// noinspection JSUnusedGlobalSymbols
export default function () {
// This code is currently not used, but for documentation on how the bootstrap-timepicker widget can be used
// and configured.

// $(function () {
//     //Documentation: http://jdewit.github.com/bootstrap-timepicker/
//     $('.timepicker').timepicker({
//         showMeridian: false,
//         defaultTime: false,
//         minuteStep: 15
//     }).on('change', function () {
//         // Allow . as separator
//         $(this).val($(this).val().replace('.', ':'));
//     });
//
//     $('.toggle-timepicker').on('click', function () {
//         $(this).prevAll('.timepicker').timepicker('showWidget');
//     });
//     $('.clear-timepicker').on('click', function () {
//         $(this).prevAll('.timepicker').val('');
//     });
// });
}